import { MDSIcon } from '@marqvision/mds-v2';

export const getIcon = (fileName: string) => {
  const extension = fileName.split('.').pop()?.toLowerCase();
  if (!extension) return <MDSIcon.AttachFile />;

  if (/(jpe?g|png)$/i.test(extension)) return <MDSIcon.Image variant="fill" />;
  if (/xlsx?$/.test(extension)) return <MDSIcon.ExcelSheet />;
  if (/pdf$/i.test(extension)) return <MDSIcon.Pdf variant="fill" />;
  if (/pptx?$/i.test(extension)) return <MDSIcon.Ppt variant="fill" />;
  if (/docx?$/i.test(extension)) return <MDSIcon.Document variant="fill" />;
  return <MDSIcon.AttachFile />;
};
